import { useState } from 'react';
import { Sheet } from '../components/Sheet';
import { useT } from '../i18n/I18nProvider';

interface Props {
  scannedCode: string;
  onClose: () => void;
  /** Vyhledání řeší App – výsledek se zobrazí na hlavní obrazovce. */
  onSearch: (orderNumber: string) => Promise<void>;
}

/**
 * Najít manuálně (spec 5c).
 *
 * Vstup má autofocus (řeší `Sheet`), Enter spouští hledání a klávesnice
 * je číselná – při 200 balících za směnu je to znatelný rozdíl.
 *
 * Pozor: z obrazovky ZÁSILKA NENALEZENA vede podle zadání jediná cesta.
 * Kdyby mělo jít pokračovat i bez dohledání, patří sem druhé, sekundární
 * tlačítko.
 */
export function FindManuallySheet({ scannedCode, onClose, onSearch }: Props) {
  const { t } = useT();
  const [value, setValue] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [searching, setSearching] = useState(false);

  async function search() {
    const orderNumber = value.trim();
    if (!orderNumber) {
      setError(t('errQuery'));
      return;
    }
    setError(null);
    setSearching(true);
    try {
      await onSearch(orderNumber);
    } finally {
      setSearching(false);
    }
  }

  return (
    <Sheet title={t('findTitle')} meta={scannedCode} onClose={onClose}>
      <div className="lbl">{t('orderNo')}</div>
      <input
        className="qinput"
        inputMode="numeric"
        placeholder={t('orderPh')}
        value={value}
        aria-label={t('orderNo')}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') void search();
        }}
      />

      {error && <div className="err">{error}</div>}

      <div className="row">
        <button className="btn primary" type="button" disabled={searching} onClick={() => void search()}>
          {searching ? t('searching') : t('search')}
        </button>
        <button className="btn ghost" type="button" onClick={onClose}>
          {t('cancel')}
        </button>
      </div>
    </Sheet>
  );
}
